// extracted by mini-css-extract-plugin
export default {"btn":"gbrAP_WPLiZYcu2P4nDX","compact":"Fv2nsAYWvTcr7xEckglg"};